/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseWarrantyAnyOf } from './GetConfig200ResponseWarrantyAnyOf';
import {
    GetConfig200ResponseWarrantyAnyOfFromJSON,
    GetConfig200ResponseWarrantyAnyOfFromJSONTyped,
    GetConfig200ResponseWarrantyAnyOfToJSON,
    GetConfig200ResponseWarrantyAnyOfToJSONTyped,
} from './GetConfig200ResponseWarrantyAnyOf';
import type { GetConfig200ResponseWarrantyAnyOf1 } from './GetConfig200ResponseWarrantyAnyOf1';
import {
    GetConfig200ResponseWarrantyAnyOf1FromJSON,
    GetConfig200ResponseWarrantyAnyOf1FromJSONTyped,
    GetConfig200ResponseWarrantyAnyOf1ToJSON,
    GetConfig200ResponseWarrantyAnyOf1ToJSONTyped,
} from './GetConfig200ResponseWarrantyAnyOf1';

/**
 * 
 * @export
 * @interface GetConfig200ResponseWarranty
 */
export interface GetConfig200ResponseWarranty {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseWarranty
     */
    type: GetConfig200ResponseWarrantyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseWarranty
     */
    method: GetConfig200ResponseWarrantyMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseWarranty
     */
    amount: number;
}


/**
 * @export
 */
export const GetConfig200ResponseWarrantyTypeEnum = {
    None: 'NONE',
    Deposit: 'DEPOSIT',
    Card: 'CARD'
} as const;
export type GetConfig200ResponseWarrantyTypeEnum = typeof GetConfig200ResponseWarrantyTypeEnum[keyof typeof GetConfig200ResponseWarrantyTypeEnum];

/**
 * @export
 */
export const GetConfig200ResponseWarrantyMethodEnum = {
    All: 'ALL',
    LargeGroups: 'LARGE-GROUPS',
    ByPerson: 'BY-PERSON'
} as const;
export type GetConfig200ResponseWarrantyMethodEnum = typeof GetConfig200ResponseWarrantyMethodEnum[keyof typeof GetConfig200ResponseWarrantyMethodEnum];


/**
 * Check if a given object implements the GetConfig200ResponseWarranty interface.
 */
export function instanceOfGetConfig200ResponseWarranty(value: object): value is GetConfig200ResponseWarranty {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseWarrantyFromJSON(json: any): GetConfig200ResponseWarranty {
    return GetConfig200ResponseWarrantyFromJSONTyped(json, false);
}

export function GetConfig200ResponseWarrantyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseWarranty {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'method': json['method'],
        'amount': json['amount'],
    };
}

export function GetConfig200ResponseWarrantyToJSON(json: any): GetConfig200ResponseWarranty {
    return GetConfig200ResponseWarrantyToJSONTyped(json, false);
}

export function GetConfig200ResponseWarrantyToJSONTyped(value?: GetConfig200ResponseWarranty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'method': value['method'],
        'amount': value['amount'],
    };
}

